import cx from 'classnames';
import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import Textarea from 'components/Textarea';

import './styles/Composer.scss';
import Text from '../../components/Text';
import { Button } from '../../components/Button';
import MediaObject from '../../components/MediaObject';

import type { KeyboardEvent } from 'react';

type Props = {
  error: boolean;
  autoFocus?: boolean | null;
  onChange: Function;
  onFocus?: Function | null;
  onBlur?: Function | null;
  onReturnKeyPress?: (e: KeyboardEvent) => boolean;
  placeholder?: string | null;
  value: string | undefined | null;
  className: string | undefined | null;
  indicator?: any;
  children?: React.ReactNode;
  rows?: number;
  autogrow?: boolean;
  constrainMaxHeight?: boolean;
  showTitle?: boolean;
  title?: string;
  hideTitleAction?: () => void;
};

class Composer extends React.Component<Props, any> {
  static defaultProps = {
    rows: 1,
  };

  state = {
    focused: false,
  };

  // @ts-expect-error ts-migrate(7023) FIXME: 'shouldComponentUpdate' implicitly has return type... Remove this comment to see the full error message
  shouldComponentUpdate(nextProps: any, nextState: any) {
    return shallowCompare(this, nextProps, nextState);
  }

  focus = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'focus' does not exist on type 'ReactInst... Remove this comment to see the full error message
    this.refs.textarea.focus();
  };

  clear = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'clear' does not exist on type 'ReactInst... Remove this comment to see the full error message
    this.refs.textarea.clear();
  };

  handleTextareaBlur = () => {
    this.setState({ focused: false });
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  handleTextareaFocus = () => {
    this.setState({ focused: true });
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  render() {
    const {
      children,
      error,
      className,
      onChange,
      placeholder,
      indicator,
      onReturnKeyPress,
      rows,
      value,
      constrainMaxHeight,
      autogrow,
      autoFocus,
      showTitle,
      title,
      hideTitleAction,
    } = this.props;

    const composerHasChildren =
      children && React.Children.toArray(children).filter((child) => !!child).length;

    return (
      <>
        <div
          className={cx(
            'Composer',
            {
              'Composer-focus': this.state.focused,
              'Composer-error': error,
            },
            className
          )}
        >
          {showTitle && title && (
            <div className="Composer-title">
              <MediaObject figure="right" gutter="small">
                <Text weight="semibold" size="medium">
                  {title}
                </Text>
                {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
                <Button size="xxxsmall" onClick={hideTitleAction}>
                  Close
                </Button>
              </MediaObject>
            </div>
          )}
          <div className="Composer-input">
            {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
            <Textarea
              autoFocus={autoFocus}
              autogrow={autogrow}
              rows={rows}
              ref="textarea"
              data-test="chat-composer"
              data-testid="chat-composer"
              data-test-selector="chat-composer"
              className={cx('Composer-input-textarea', {
                'Composer-input-textarea-constrain': constrainMaxHeight,
              })}
              onFocus={this.handleTextareaFocus}
              onBlur={this.handleTextareaBlur}
              onReturnKeyPress={onReturnKeyPress}
              onChange={onChange}
              value={value}
              placeholder={placeholder}
            />
            {indicator ? <div className="Composer-input-indicator">{indicator}</div> : null}
          </div>
          {composerHasChildren ? <div className="Composer-content">{children}</div> : null}
        </div>
      </>
    );
  }
}

export default Composer;
